import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchContract } from 'app/actions/ContractActions';
import { getContract } from 'app/reducers';
import isEmpty from 'app/utils/IsEmpty';

export default function ContractContainer(props) {
    let dispatch = useDispatch();
    let contract = useSelector(getContract);

    useEffect(() => {
        if (isEmpty(contract)) fetchContractAction();
    }, []);
    const fetchContractAction = () => dispatch(fetchContract());
    
    return (props.children({ contract }));
}